import { createApp } from 'vue'
import App from './App.vue'
import { Swiper, SwiperSlide } from 'swiper/vue';

import "@/assets/vendor/icofont/icofont.min.css";

import "@/assets/vendor/venobox/venobox.css";

import "@/assets/css/style.css";

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';



const app = createApp(App)

app.component('swiper', Swiper);
app.component('swiper-slide', SwiperSlide);

app.mount('#app')
